import React, { useState } from "react";
import "./LoginPage.css";

interface LoginPageProps {
  onLogin?: (secretKey: string) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  const [secretKey, setSecretKey] = useState("");
  const [showKey, setShowKey] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!secretKey.trim()) {
      setError("Please enter your secret key.");
      return;
    }

    setLoading(true);
    setError(null);

    // Mock verification delay to demonstrate design transitions
    setTimeout(() => {
      setLoading(false);
      if (secretKey.trim() === "123") {
        if (onLogin) {
          onLogin(secretKey.trim());
        }
      } else {
        setError("Invalid secret key");
      }
    }, 1000);
  };


  return (
    <div className="login-container">
      <div className="login-card">
        {/* Card header */}
        <div className="login-header">
          <img
            src="/ss2.png"
            alt="École des Ponts Logo"
            className="login-logo"
          />
          <h1 className="login-title">École des Ponts Admin</h1>
          <p className="login-subtitle">
            Enter your secret key to access the panel
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="login-form">
          {/* Error banner */}
          {error && (
            <div className="login-error-banner">
              <i className="fa-solid fa-circle-exclamation login-error-icon" />
              <span>{error}</span>
            </div>
          )}

          {/* Secret Key Input */}
          <div className="login-field-group">
            <label htmlFor="secret-key" className="login-label">
              Secret Key
            </label>
            <div className="login-input-wrapper">
              <i className="fa-solid fa-lock login-input-icon" />
              <input
                id="secret-key"
                type={showKey ? "text" : "password"}
                value={secretKey}
                onChange={(e) => {
                  setSecretKey(e.target.value);
                  setError(null);
                }}
                placeholder="Enter your secret key"
                autoComplete="current-password"
                className="login-input"
              />
              <button
                type="button"
                onClick={() => setShowKey((prev) => !prev)}
                className="login-input-toggle"
                tabIndex={-1}
                aria-label={showKey ? "Hide secret key" : "Show secret key"}
              >
                <i className={showKey ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"} />
              </button>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="login-submit-btn"
          >
            {loading ? (
              <>
                <i className="fa-solid fa-spinner login-spinner" />
                <span>Verifying…</span>
              </>
            ) : (
              <>
                <i className="fa-solid fa-right-to-bracket" />
                <span>Sign In</span>
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
